// Copyright (c) 2020 Deere & Company

import RgaWip from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import reports from '../../routes/rga/reports';

const getStateToBindToContainerProps = state => ({
    ...state.rga.search,
    ...state.rga.shared,
    links: state.app.links,
    reportsRoutes: reports,
    security: state.user.security,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {children, routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        children,
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(RgaWip);



// WEBPACK FOOTER //
// ./src/rga/search/state-connector.js